import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import InputUI from '../../../components/UI/InputUI';
import { translate, convertToSeparator, convertToDecimal } from '../../../utils/util';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import BackButton from '../../../components/UI/BackButton';
import { ListPagination } from '../../../components/UI/ComponentsUI';

const Monitor = (props) => {
    const [data, setData] = useState([]);
    const [partNumber, setPartNumber] = useState('');
    const hotRequest = props.location?.state?.hotRequest;
    const inDock = props.location?.state?.inDock;
    const [currentPage, setCurrentPage] = useState(0);
    const [result, setResult] = useState();

    useEffect(() => {
        if (currentPage > 0) {
            onClickButton(false);
        }
        // eslint-disable-next-line
    }, [currentPage]);

    useEffect(() => {
        if (result?.items?.length > 0) {
            if (data.length > 0 && currentPage === 0) {
                setData(result.items);
            } else {
                setData((prevState) => ([...prevState, ...result.items]));
            }
        } else {
            setData([]);
        }
        // eslint-disable-next-line
    }, [result?.items]);

    useEffect(() => {
        onClickButton();
        // eslint-disable-next-line
    }, []);

    const onClickButton = (click) => {
        var currentPageList = currentPage;
        if (click) {
            currentPageList = 0;
            setCurrentPage(0);
            setData([]);
        }

        props.getPartNumbers({
            partNumber: partNumber,
            shed: props.user.shed,
            hotRequest: hotRequest,
            InDock: inDock,
            PageSize: 12,
            PageIndex: currentPageList
        }, (response) => {
            setResult(response)
        });
    }

    const renderItem = (item) => {
        return (
            <div
                key={`${item.id}`}
                className="collection-item avatar z-depth-1"
                style={{ backgroundColor: 'white', color: 'black', display: 'block' }}
            >
                <div className="row" style={{ marginBottom: '0px' }}>
                    <p className="crop-text-250">{item.receipt.physicalConfirmation.mvmNumber}</p>
                    <p className="crop-text-250">{item.receipt.partNumberCode}</p>
                    <p className="crop-text-250">{item.receipt.partNumberDescription}</p>
                </div>
                <div className="row" style={{ marginBottom: '0px' }}>
                    <div className="col s4" style={{ padding: '0px' }}>
                        <small>{`${translate('physical-confirmation:qme')}: ${convertToSeparator(item.receipt.qme) || ''}`}</small>
                    </div>
                    <div className="col s8" style={{ padding: '0px' }}>
                        <small>{`${translate('physical-confirmation:qt-records')}: ${convertToDecimal(item.boxQuantity) || ''}`}</small>
                    </div>
                    <div className="col s4" style={{ padding: '0px' }}>
                        <small>{`${translate('available', 'general')}: ${convertToSeparator(item.receipt.balance) || ''}`}</small>
                    </div>
                    <div className="col s8" style={{ padding: '0px' }}>
                        <small>{`${translate('physical-confirmation:mdr')}: ${item.mdr || ''}`}</small>
                    </div>
                    <div className="col s4" style={{ padding: '0px' }}>
                        <small>{translate('physical-confirmation:quantity-receipt-total')}: {item.receipt.accoutingQuantity - item.receipt.balance || 0}</small>
                    </div>
                    <div className="col s8" style={{ padding: '0px' }}>
                        <small>{translate('physical-confirmation:note')}: {item.receipt.invoice || ''}</small>
                    </div>
                    <div className="col s4" style={{ padding: '0px' }}>
                        <small>{`${translate('physical-confirmation:dock')}: ${item.preAllocationArea}`}</small>
                    </div>
                    <div className="col s8" style={{ padding: '0px' }}>
                        <small>{`${translate('inventory:quantity')}: ${item.boxQuantity}`}</small>
                    </div>
                    <div>
                        <div className="col s12" style={{ padding: '0px' }}>
                            <small><b>{translate('physical-confirmation:in-entrace-area')}</b></small>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65" />
            <div className="container">
                <div className="card">
                    <div className="card-content" style={{ padding: '0px', paddingTop: '5px', marginTop: '20px' }}>
                        <div className="row">
                            <div className="col s9">
                                <div className="form-group">
                                    <div className="input-field">
                                        <InputUI
                                            id="partNumber"
                                            name="partNumber"
                                            placeholder="Digite o Desenho"
                                            type="number"
                                            min={0}
                                            defaultValue={partNumber}
                                            onChange={(e) => setPartNumber(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col s3 center">
                                <button
                                    className="btn-floating btn-large btn-principal waves-effect waves-light"
                                    type="button"
                                    onClick={onClickButton}
                                >
                                    <i className="material-icons">search</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ul className="collection col s12" style={{ paddingLeft: 0, paddingRight: 0 }}>
                <ListPagination
                    page={result?.totalPages}
                    current={{ currentPage, setCurrentPage }}
                    data={
                        data.map((item) => {
                            return (
                                renderItem(item)
                            );
                        })
                    }
                />
            </ul>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPartNumbers: (filter, callback) => {
            dispatch(PhysicalConfirmationService.getMonitorPartNumber(filter, callback));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Monitor));